export enum ButtonTypes {
  Text = 'TextButton',
  RunFlowNode = 'RunFlowNodeButton',
  FlowFormButton = 'FlowFormButton',
  Share = 'Share',
  TriggerCall = 'TriggerCall',
  UserPropRedirect = 'UserPropRedirect',
  Reaction = 'Reaction',
  PalmsReaction = 'PalmsReaction',
  FingerUpReaction = 'FingerUpReaction',
  FingerDownReaction = 'FingerDownReaction',
  Link = 'Link',
  RunFlowButton = 'RunFlowButton',
  FormAnswerButton = 'FormAnswerButton',
  ShareTextButton = 'ShareTextButton',
  FormButton = 'FormButton',
  PopupButton = 'PopupButton',
  RedirectButton = 'RedirectButton',
}

/** BaseButton используется как интерфейс, все кнопки это имплементация этого класса */
export class BaseButton {
  guid!: string
  type!: ButtonTypes | string
  text!: string
}
